<template lang="pug">
  .col.d-flex.align-items-center.cursor-pointer
    icon(icon="fa-solid fa-grip-vertical").mr-6
    div
      .d-flex.align-items-center.line-1.mb-1
        icon.font-size-micro.text-99.mr-3(:icon="addressIcon")
        span.font-weight-semibold.font-size-base.text-26.text-ellipsis {{ address.name }}
      .font-size-md.line-1.text-73(v-if="address")
        template(v-if="address.street") {{address.street}}
        template(v-if="address.house_number") ,&nbsp;{{address.house_number}}
        template(v-if="address.floor_number") ,&nbsp;{{address.floor_number}}
        template(v-if="address.door_number") ,&nbsp;{{address.door_number}}
        template(v-if="address.bell_number") ,&nbsp;{{address.bell_number}}
        template(v-if="address.sub_address") ,&nbsp;{{address.sub_address}}
        br
        template(v-if="address.town") {{address.town}}
        template(v-if="address.zip_code") ,&nbsp;{{address.zip_code}}
</template>
<script>
export default {
    props: {
        address: {
            type: Object,
        },
    },
    computed: {
        addressIcon() {
            return `fa-solid ${
                this.address.is_company_address ? 'fa-briefcase' : 'fa-location-arrow'
            }`
        },
    },
}
</script>
